import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface VideoRecordingErrorBottomSheetProps {
  modalState: UseModalState;
  errorText: string | undefined;
  isLoading: boolean;
  onRetry: () => Promise<void>;
  onGoBack: () => void;
}

export function VideoRecordingErrorBottomSheet(props: VideoRecordingErrorBottomSheetProps) {
  const { modalState, errorText, isLoading, onRetry, onGoBack } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" onClose={onGoBack}>
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={async () => {
              await onRetry();
            }}
          >
            Retry
          </LoadingButton>
          <Button fullWidth variant="outlined" size="large" onClick={onGoBack}>
            Go back
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="error"
        title="Camera error"
        description={errorText ?? "There was an error with the camera. Please try again."}
      />
    </BottomSheet>
  );
}
